import store from '../../fg/v2/base/store';

const initializeResponseHandler = (response) => {
    usableConfig = response.features;
}

const interruptGameplayHandler = () => {

}

const visibilityChangeHandler = () => {

}

const refreshBalanceHandler = () => {

}

const closeGameHandler = () => {
    let request = {
        _type: "ucip.closegame.w2gCloseGameRequest"
    };

    sendMessageToUpperFrame(request);
}

const soundUpdateHandler = () => {

}


const gamePauseHandler = (request) => {
    store.commit('setPopGracefulPause', request.pause);

    if (!request.pause) {
        sendGamePauseNotification(false);
    }
}

const sendLoadingStartNotification = () => {

}

const sendPlayForRealNotification = () => {

}

const sendGameChangeNotification = () => {

}

const sendSwitchGameCommand = () => {

}

const sendOpenPageCommand = () => {

}

const sendSoundUpdateNotification = () => {

}

const sendCloseGameErrorResponse = () => {

}

const sendCloseGameResponse = () => {

}

const sendAutoplayStartNotification = () => {

}

const sendAutoplayEndNotification = () => {

}

const sendLoadingProgressNotifications = () => {

}

const sendLoadingEndNotifications = () => {

}

const sendGameReadyNotification = () => {

}

const sendErrorNotification = () => {

}

const sendGameRoundStartNotification = () => {

}

const sendGameRoundEndNotification = () => {

}

const sendBalanceUpdateNotification = () => {

}

const sendGamePauseNotification = (paused) => {
    let request = {
        _type: "ucip.pause.g2wPauseNotification",
        pause: paused
    }

    sendMessageToUpperFrame(request);
}

const sendRefreshBalanceNotification = () => {

}

const betUpdateNotification = () => {

}

const sendInitializationRequest = () => {
    let request = {
        _type: "ucip.basic.g2wInitializationRequest",
        version: "1.0.0",
        features: gameConfig,
    }

    sendMessageToUpperFrame(request)
}

const startAutoplay = () => {

}

const stopAutoPlay = () => {

}

const pauseGame = () => {
    g2wMappings["ucip.pause.g2wPauseNotification"](true);
}


const setGameConfiguration = (parameters) => {
    gameConfig = parameters;

    sendInitializationRequest();
}

let gameConfig;
let usableConfig;

const sendMessageToUpperFrame = (request) => {
    if (Config.popParameters) {
        let requestString = JSON.stringify(request);
        window.parent.postMessage(requestString, '*');
    }
}

const w2gMappings = {
    "ucip.basic.w2gInitializationResponse": initializeResponseHandler,
    "ucip.autoplay.w2gInterruptGameplayCommand": interruptGameplayHandler,
    "ucip.pause.w2gPauseCommand": gamePauseHandler,
    "ucip.displaystatus.w2gVisibilityChangeNotification": visibilityChangeHandler,
    "ucip.sound.w2gSoundUpdateNotification": soundUpdateHandler,
    "ucip.balancerefresh.w2gRefreshBalanceCommand": refreshBalanceHandler,
    "ucip.closegame.w2gCloseGameRequest": closeGameHandler,
}

const g2wMappings = {
    "ucip.pause.g2wPauseNotification": sendGamePauseNotification,
    "ucip.autoplay.g2wAutoplayStartNotification": sendAutoplayStartNotification,
    "ucip.autoplay.g2wAutoplayEndNotification": sendAutoplayEndNotification,
    "ucip.closegame.g2wCloseGameResponse": sendCloseGameResponse,
    "ucip.closegame.g2wCloseGameErrorResponse": sendCloseGameErrorResponse,
    "ucip.sound.g2wSoundUpdateNotification": sendSoundUpdateNotification,
    "ucip.openpage.g2wOpenPageCommand": sendOpenPageCommand,
    "ucip.switchgame.g2wSwitchGameCommand": sendSwitchGameCommand,
    "ucip.gamechange.g2wGameChangeNotification": sendGameChangeNotification,
    "ucip.switchmode.g2wPlayForRealCommand": sendPlayForRealNotification,
    "ucip.loadingstatus.g2wLoadingStartNotification": sendLoadingStartNotification,
    "ucip.loadingstatus.g2wLoadingProgressNotification": sendLoadingProgressNotifications,
    "ucip.loadingstatus.g2wLoadingEndNotification": sendLoadingEndNotifications,
    "ucip.loadingstatus.g2wGameReadyNotification": sendGameReadyNotification,
    "ucip.errors.g2wErrorNotification": sendErrorNotification,
    "ucip.gameround.g2wGameRoundStartNotification": sendGameRoundStartNotification,
    "ucip.gameround.g2wGameRoundEndNotification": sendGameRoundEndNotification,
    "ucip.balanceupdate.g2wBalanceUpdateNotification": sendBalanceUpdateNotification,
    "ucip.balancerefresh.w2gRefreshBalanceCommand": sendRefreshBalanceNotification,
    "ucip.betupdate.g2wBetUpdateNotification": betUpdateNotification,
    'ucip.basic.g2wInitializationRequest': sendInitializationRequest,
}

window.onmessage = function (e) {
    if (Config.popParameters) {
        let jsonObj;

        try {
            jsonObj = JSON.parse(e.data);
        } catch (e) {
            return;
        }

        (w2gMappings[jsonObj._type] != null) ? w2gMappings[jsonObj._type](jsonObj) : console.log("[GAME ERROR]: Undefined request");
    }
};

export { w2gMappings, g2wMappings, pauseGame, closeGameHandler, setGameConfiguration };